import React from "react";
import { Warning } from "shared";
import { useGetSettings } from "hooks/settings";
import { useGetMe } from "hooks/auth";
import { isPacketEnought } from "utils";
import { PACKET_ENUM, ROUTE_ENUM } from "enums";
import { useNavigate } from "react-router";
import "./NotificationWarning.scss";

interface NotificationWarningProps {
  view: "posts" | "companies" | "analyzes";
}

const NotificationWarning: React.FC<NotificationWarningProps> = ({ view }) => {
  const { data: settings } = useGetSettings();
  const { data: authorizedUser } = useGetMe();
  const navigate = useNavigate();

  if (!authorizedUser?.package) {
    return null;
  }

  const getSettingsKeys = () => {
    const userPacket = authorizedUser?.package;
    const keys = [];
    if (isPacketEnought(userPacket, PACKET_ENUM.BASIC)) {
      keys.push("isSendBoughtInReliance");
    }

    if (isPacketEnought(userPacket, PACKET_ENUM.STANDARD)) {
      keys.push("isSendInOffer");
    }
    if (isPacketEnought(userPacket, PACKET_ENUM.PREMIUM)) {
      keys.push("isSendBoughtOutside");
    }
    if (isPacketEnought(userPacket, PACKET_ENUM.PRO)) {
      keys.push("isSendMarketAnalysis");
    }
    return keys;
  };

  const settingsKeys = getSettingsKeys();

  const checkIfNotEnabled = () => {
    const settingsMap = new Map();

    settings?.forEach((setting) => {
      const settingName = setting.name.split("-")[0];
      if (settingsKeys.includes(settingName)) {
        if (!setting.valueBoolean && !settingsMap.has(settingName)) {
          settingsMap.set(settingName, setting);
        }
      }
    });

    return Array.from(settingsMap.values());
  };

  const notEnabledSettings = () => {
    const disabledSettings = checkIfNotEnabled();

    return disabledSettings
      .filter((setting) => {
        const baseName = setting.name.split("-")[0];

        if (authorizedUser.email) {
          const emailEnabled = settings?.find(
            (s) => s.name === `${baseName}-email`
          )?.valueBoolean;
          const smsEnabled = settings?.find(
            (s) => s.name === `${baseName}-sms`
          )?.valueBoolean;
          return !emailEnabled && !smsEnabled;
        } else {
          const smsEnabled = settings?.find(
            (s) => s.name === `${baseName}-sms`
          )?.valueBoolean;
          return !smsEnabled;
        }
      })
      .map((setting) => setting.name.split("-")[0]);
  };

  const notEnabledSettingsList = notEnabledSettings();
  if (notEnabledSettingsList.length === 0) return null;
  console.log("notEnabledSettingsList", notEnabledSettingsList);

  const profileNav = (
    <b onClick={() => navigate(ROUTE_ENUM.PROFILE, { state: { tab: 2 } })}>
      ustawień w zakładce profil
    </b>
  );
  const isSendBoughtInRelianceWarning = (
    <p>
      Powiadomienia dotyczące spółek zakupionych w Reliance zostały wyłączone.
      Aby to zmienić, należy przejść do {profileNav}.
    </p>
  );
  const isSendInOffer = (
    <p>
      Powiadomienia dotyczące spółek w ofercie Reliance zostały wyłączone. Aby
      to zmienić, należy przejść do {profileNav}.
    </p>
  );
  const isSendBoughtOutside = (
    <p>
      Powiadomienia dotyczące spółek zakupionych poza Reliance zostały
      wyłączone. Aby to zmienić, należy przejść do {profileNav}.
    </p>
  );
  let textOnWarning = null;
  switch (view) {
    case "posts":
      if (notEnabledSettingsList.includes("isSendBoughtOutside")) {
        textOnWarning = isSendBoughtOutside;
      }
      if (notEnabledSettingsList.includes("isSendInOffer")) {
        textOnWarning = isSendInOffer;
      }
      if (notEnabledSettingsList.includes("isSendBoughtInReliance")) {
        textOnWarning = isSendBoughtInRelianceWarning;
      }
      break;
  }
  if (textOnWarning) {
    return (
      <Warning
        text={textOnWarning}
        styleType={"gray"}
        className="notification-warning"
      />
    );
  }
  return null;
};

export default NotificationWarning;
